import { RequestService } from '../../../../common/services/RequestService';
import { UPDATE_EMPLOYEE } from '../constants';

import {
  dataAdjustmentRequest,
  dataAdjustmentResponse,
} from './dataAdjustment';

export const updateEmployeeRequest = async (idProfile, formData) => {
  console.log('updateEmployeeData', formData);
  console.log(
    'updateEmployeeData (данные для отправки)',
    dataAdjustmentRequest(formData)
  );

  const response = await RequestService.put(
    UPDATE_EMPLOYEE + idProfile,
    dataAdjustmentRequest(formData)
  );
  return {
    id: formData.profileId,
    data: dataAdjustmentResponse(response.data),
  };
};
